import { map } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../models/user';
import { ConfigService } from '../services/config.service';
import { Observable } from 'rxjs';

@Pipe({
    name: 'userIdToName',
    standalone: true
})
export class UserIdToNamePipe implements PipeTransform {
  constructor(private configService: ConfigService) {}

  transform(value: any, initails?: any): Observable<string> {
    let name = '';
    return this.configService.allUsers.pipe(
      map((users) => {
        if (!users) {
          return name;
        }
        users.forEach((userOb) => {
          if (userOb.id === +value) {
            if (initails) {
              name = this.getInitials(userOb);
            } else {
              name = userOb.name;
            }
          }
        });
        return name;
      })
    );
  }

  getInitials(user: User) {
    if (!user.name) {
      return '';
    }

    const names = user.name.split(' ');

    if (names.length === 1) {
      return names[0].charAt(0);
    }

    return names[0].charAt(0) + names[names.length - 1].charAt(0);
  }
}
